/** Redirections pures des anciennes URLs `/clients*` (QP1) — testées dans tests/unit/router/redirects.test.ts. */
import type { LocationQuery, RouteLocationRaw } from 'vue-router';

/** Cible commune des anciens aperçus client : /tickets?clientId=<id>&view=client[&issue=<uuid>]. */
export function clientPreviewRedirect(to: {
  params: Record<string, string | string[]>;
  query: LocationQuery;
}): RouteLocationRaw {
  const raw = to.params.id;
  const clientId = Array.isArray(raw) ? raw[0] : raw;
  const issue = to.query.issue;
  const query: Record<string, string> = { clientId: clientId ?? '', view: 'client' };
  if (typeof issue === 'string' && issue !== '') query.issue = issue;
  // `params: {}` obligatoire : sinon vue-router recopie `{ id }` et avertit « Discarded invalid param(s) ».
  return { name: 'issues', params: {}, query };
}
